import { Link } from 'react-router-dom'
import logo from "../img/logo-eventa.png";
import {useState, useEffect} from "react"; 


const Nav = () => {
  return (

   <>
   <nav className="navbar">

      <div className="align-items-center">
         <Link className="navbar-brand" to="/">
            <img src={logo} className="logo" alt="logo" height="350" />
          </Link>
      </div>
    </nav>
   
   </>
  )
}


export default Nav
